import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import innovation from "../../../assets/icons/innovation.svg";
import ideas from "../../../assets/icons/people.svg";
import inclusion from "../../../assets/icons/human-rights.png";
import focus from "../../../assets/icons/focus.png";

const cardStyle = {
  bgcolor: "#fff",
  color: "#000",
};

const objectList = [
  {
    icon: innovation,
    title: "Innovative Approach",
    subtitle:
      "AIR Fund prioritizes African-led solutions, integrating cutting-edge methodologies such as AI and data-driven tools to address localized challenges. By combining bold investments in proven models with support for emerging ideas, AIR Fund balances stability with experimentation.",
  },
  {
    icon: ideas,
    title: "Measurable Impact",
    subtitle:
      "Every dollar invested in resilience yields up to $6 in avoided losses and economic gains. AIR Fund focuses on initiatives with demonstrable outcomes, from saving lives with climate-smart interventions to creating jobs and driving productivity in secondary cities.",
  },
  {
    icon: inclusion,
    title: "Equity and Inclusion",
    subtitle:
      " AIR Fund is committed to empowering historically excluded groups, such as women, youth, and people with disabilities, ensuring that its resources reach those with the greatest potential for transformative impact.",
  },
  {
    icon: focus,
    title: "A Unique Focus",
    subtitle:
      "While many funds concentrate on Africa’s primary cities, AIR Fund turns its attention to secondary cities—untapped engines of growth with extraordinary potential to bolster regional resilience and productivity.",
  },
];

const WhyPartner = () => {
  return (
    <Box margin={{ xs: "35% 0%", sm: "10% 0% 10% 0%" }} data-aos={"fade-up"}>
      <Typography
        variant="h3"
        fontWeight={700}
        textAlign={"left"}
        paddingBottom={{ xs: "4%", sm: "4%" }}
        color={"#39484E"}
      >
        Why Partner with AIR?
      </Typography>
      <Grid container spacing={1}>
        {objectList.map((list, index) => {
          const { title, icon, subtitle } = list;
          return (
            <>
              <Grid
                item
                xs={12}
                sm={6}
                md={3}
                margin={{ xs: "5% 0%", sm: "0%" }}
              >
                <Box
                  key={index}
                  component={Card}
                  height={"100%"}
                  padding={{ xs: "4% 4%", sm: "8% 8% 4% 8%" }}
                  margin={{ xs: "2% 0%", sm: "4% 0%" }}
                  borderRadius={"20px"}
                  display={"flex"}
                  flexDirection={"column"}
                  width={{ xs: "100%", sm: "100%" }}
                  sx={{ ...cardStyle }}
                >
                  <Box marginLeft={"2%"}>
                    {" "}
                    <Box
                      component="img"
                      height={{ xs: "64px", sm: "64px" }}
                      sx={{
                        objectFit: "cover",
                        overflow: "hidden",
                        width: "100%",
                      }}
                      src={icon}
                      alt={"icons"}
                    />
                  </Box>
                  <Typography
                    variant={"h5"}
                    fontWeight={700}
                    paddingTop={"6%"}
                    color={"#213555"}
                  >
                    {title}
                  </Typography>
                  <Typography
                    variant={"body1"}
                    paddingTop={"6%"}
                    color={"#000"}
                  >
                    {subtitle}
                  </Typography>
                </Box>
              </Grid>
            </>
          );
        })}
      </Grid>
    </Box>
  );
};

export default WhyPartner;
